export default "__VITE_ASSET__78da6208__"